export default __webpack_public_path__ + "static/media/regreen_visual_08.d0d1d832.jpg";